import React from 'react';
import strings from 'helper/localization/localization';

/**
 * Page user is redirected to when successfully resetting their password.
 */

const ResetPasswordSuccess = () => (
  <div className="container">
    <div className="row mb-2">
      <div className="col">
        <h1>{strings.resetPasswordSuccess}</h1>
      </div>
    </div>

    <div className="row mb-4">
      <div className="col">
        <p>{strings.resetPasswordSuccessInstructions}</p>
      </div>
    </div>

    <div className="row">
      <div className="col text-center">
        <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 100 100">
          <g fill="none" fillRule="evenodd" stroke="#23D7A2">
            <path strokeWidth="2" d="M99 50C99 22.938 77.062 1 50 1 22.94 1 1 22.938 1 50s21.939 49 49 49c27.062 0 49-21.938 49-49z" />
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M28.283 54.127l14.246 15.57 28.178-37.374" />
          </g>
        </svg>
      </div>
    </div>
  </div>
);

export default ResetPasswordSuccess;



// WEBPACK FOOTER //
// ./src/modules/login/ResetPasswordSuccess.jsx